import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment'
import 'moment/locale/pt-br';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { BrowserRouter as Router, Route, Routes, Outlet, Navigate, BrowserRouter } from "react-router-dom";

import "./App.less";
import { Login, Home, Venda, Resumo, Clientes, FinalizarVenda, VendaRealizada, DevolucaoVenda, Parcelas, ParametrosEmpresa, SemAcesso } from "./pages";
import { StateProvider } from './state';
import { assumirPDV, isAuthenticated, LOCK_PAGE_KEY, pegarOuCriarTabId } from './services/auth';
import { reducer } from './state/reducer';

function App() {

    moment.locale('pt-br');

    const initialState = {
        userConfig: { size: 'small' },
        ui: { showDrawer: false, showDrawerExtra: false },
        manutencao: { dados: null },
        dadosPdv: { pdv: null },
        listaSelectPaginado: { itens: [] },
        listaTabelaDados: { itens: [] },
        listagem: { filtro: '', ordem: '', outrosFiltros: '' },
        tributacao: { empRegimeTributario: null, empEnquadramentoFiscal: null },
        parametrosEmpresa: { markupProduto: null, par_percjuromesparcelavencida: '', par_multaparcelavencida: '', par_diastoleranciacobrancajuro: '', par_tipocalculomulta: '', par_acaoparcelavencida: '', par_diastolparcelavencida: '' }
    };

    /*   const PrivateRoute = () => {
          return isAuthenticated() ? (
              <Outlet />
          ) : (
              <Navigate to="/login" />
          )
      }; */
    const PrivateRoute = ({ children }) => {
        return isAuthenticated() ? children : <Navigate to="/" />;
    };

    const [pdvBloqueado, setPdvBloqueado] = useState(false);
    const tabIdRef = useRef(null);

    useEffect(() => {
        tabIdRef.current = pegarOuCriarTabId();
        assumirPDV();

        if (isAuthenticated() && window.location.pathname !== "/home") {
            window.location.replace("/home");
        }

        const onStorage = (event) => {
            if (event.key !== LOCK_PAGE_KEY) return;
            if (!event.newValue) return;

            const lock = JSON.parse(event.newValue);

            if (lock.tabId !== tabIdRef.current) {
                setPdvBloqueado(true);
            }
        };

        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    return (
        <StateProvider initialState={initialState} reducer={reducer}>
            <ConfigProvider locale={ptBR} componentSize="small">
                <Router>
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/home" element={<PrivateRoute><Home pdvBloqueado={pdvBloqueado} /></PrivateRoute>} >
                            <Route index element={<Resumo />} />
                            <Route path="venda" element={<Venda />} />
                            <Route path="clientes" element={<Clientes />} />
                            <Route path="venda/finalizarVenda" element={<FinalizarVenda />} />
                            <Route path="vendaRealizada" element={<VendaRealizada />} />
                            <Route path="devolucaoVenda" element={<DevolucaoVenda />} />
                            <Route path="parcelas" element={<Parcelas />} />
                            <Route path="parametrosEmpresa" element={<ParametrosEmpresa />} />
                            <Route path="semAcesso" element={<SemAcesso />} />
                        </Route>
                        {/* <Route path="*" element={<Home />} /> */}
                    </Routes>
                </Router>
            </ConfigProvider>
        </StateProvider >
    );
}

export default App;